import {
    LIST_LICENCE_TYPES,
    LIST_LICENCE_TYPES_SUCCESS,
    LIST_LICENCE_TYPES_ERROR,
    ADD_LICENCE_TYPES,
    SAVE_LICENCE_TYPES,
    SAVE_LICENCE_TYPES_SUCCESS,
    SAVE_LICENCE_TYPES_ERROR,
    DELETE_LICENCE_TYPES,
    DELETE_LICENCE_TYPES_SUCCESS,
    DELETE_LICENCE_TYPES_ERROR,
    EDIT_LICENCE_TYPES,
    UPDATE_LICENCE_TYPES,
    UPDATE_LICENCE_TYPES_SUCCESS,
    UPDATE_LICENCE_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'licencia-tipo';

//LISTAR DEPENDENCY TYPES
export function listLicenceTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listLicenceTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const licenceTypes = response.data;
            //Llamo al dispatch
            dispatch( listLicenceTypesSuccess(licenceTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listLicenceTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listLicenceTypes = () => ({
    type: LIST_LICENCE_TYPES,
    payload: true
});

const listLicenceTypesSuccess = licenceTypes => ({
    type: LIST_LICENCE_TYPES_SUCCESS,
    payload: licenceTypes
});

const listLicenceTypesError = error => ({
    type: LIST_LICENCE_TYPES_ERROR,
    payload: error
});

//ADD DEPENDENCY TYPE
export function addLicenceTypesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addLicenceTypes(false) );
        //Abro el formulario
        showForm();
    }
}

const addLicenceTypes = isEdit => ({
    type: ADD_LICENCE_TYPES,
    payload: isEdit
});

//SAVE DEPENDENCY TYPE
export function saveLicenceTypesAction(licenceType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveLicenceTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, licenceType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveLicenceTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveLicenceTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveLicenceTypes = () => ({
    type: SAVE_LICENCE_TYPES,
    payload: true
});


const saveLicenceTypesSuccess = licenceType => ({
    type: SAVE_LICENCE_TYPES_SUCCESS,
    payload: licenceType
});

const saveLicenceTypesError = error => ({
    type: SAVE_LICENCE_TYPES_ERROR,
    payload: error
});

//EDIT DEPENDENCY TYPE
export function editLicenceTypesAction(licenceType, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editLicenceTypes(licenceType) );
        //Abro el formulario
        showForm();
    }
}

const editLicenceTypes = licenceType => ({
    type: EDIT_LICENCE_TYPES,
    payload: licenceType
});

//UPDATE DEPENDENCY TYPE
export function updateLicenceTypesAction(licenceType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateLicenceTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${licenceType.id}`, licenceType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateLicenceTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateLicenceTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateLicenceTypes = () => ({
    type: UPDATE_LICENCE_TYPES,
    payload: true
});

const updateLicenceTypesSuccess = licenceType => ({
    type: UPDATE_LICENCE_TYPES_SUCCESS,
    payload: licenceType
});

const updateLicenceTypesError = error => ({
    type: UPDATE_LICENCE_TYPES_ERROR,
    payload: error
});

//DELETE DEPENDENCY TYPE
export function deleteLicenceTypesAction(licenceType) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteLicenceTypes() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${licenceType.id}`);
            const response = await clienteAxios.put(`/${controller}/${licenceType.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteLicenceTypesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteLicenceTypesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteLicenceTypes = () => ({
    type: DELETE_LICENCE_TYPES,
    payload: true
});

const deleteLicenceTypesSuccess = licenceType => ({
    type: DELETE_LICENCE_TYPES_SUCCESS,
    payload: licenceType
});

const deleteLicenceTypesError = error => ({
    type: DELETE_LICENCE_TYPES_ERROR,
    payload: error
});